
export const CREATE_NEW_LIST_NAME = "Create New List";

export interface AudienceListOption {
  name: string;
  displayName: string;
  description?: string;
  customerCount?: number;
}

export interface ApiAudienceList {
  name: string;
  display_name?: string;
  list_type?: string;
  list_type_label?: string;
  description?: string | null;
  customers_count?: number | null;
}

export interface ApiAudienceListsResponse {
  lists?: ApiAudienceList[];
  list_names?: string[];
}

const displayNameByName = new Map<string, string>();

export const registerAudienceListLabels = (
  options: AudienceListOption[],
): AudienceListOption[] => {
  options.forEach(option => {
    displayNameByName.set(option.name, option.displayName || option.name);
  });
  return options;
};

export const getAudienceListDisplayName = (name: string): string =>
  displayNameByName.get(name.trim()) ?? name;

export const toAudienceListOptions = (
  response: ApiAudienceListsResponse | null | undefined,
): AudienceListOption[] => {
  const lists = response?.lists;
  if (Array.isArray(lists) && lists.length > 0) {
    return lists
      .filter(list => Boolean(list?.name))
      .map(list => ({
        name: list.name,
        displayName: list.display_name || list.name,
        description: list.description ?? undefined,
        customerCount: list.customers_count ?? undefined,
      }));
  }

  return (response?.list_names ?? []).map(name => ({ name, displayName: name }));
};

export const audienceListMatchesSearch = (
  option: AudienceListOption,
  search: string,
): boolean => {
  const term = search.trim().toLowerCase();
  if (!term) {
    return true;
  }
  return (
    option.displayName.toLowerCase().includes(term) ||
    option.name.toLowerCase().includes(term)
  );
};
